/**
 * Space is TAKE — RundownEditor's hotkey fires it anywhere outside a text field.
 * dnd-kit's KeyboardSensor listens for Space too, to pick a cue up and put it
 * down, on whichever drag handle has focus. A handle took focus when clicked and
 * kept it after a mouse drag, so the next TAKE also lifted the cue and the one
 * after that dropped it. Keyboard reordering keeps Enter; Space belongs to TAKE.
 */
export const RUNDOWN_KEYBOARD_CODES = {
  start: ['Enter'],
  cancel: ['Escape'],
  end: ['Enter', 'Tab'],
};

/**
 * Spread on a drag handle: grabbing it neither focuses the handle nor leaves an
 * edited field focused behind it — the operator's next Space must reach TAKE,
 * not a handle and not a text box. Blurring a field saves it, as before.
 */
export const noMouseFocus = {
  onMouseDown: (e) => {
    e.preventDefault();
    if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
  },
};
